import React from 'react'

import { Form } from '_zari/core'

import { MesesContabilidadConstant } from 'constants/index'

const MesContabilidad = ({ mesFin = 12, ...props }) => {
  const selectOpions = React.useMemo(() => {
    const salida = []
    for (let i = 0; i <= mesFin; i++) {
      const element = MesesContabilidadConstant.__array[i]
      salida.push(
        <option key={i} value={element.id}>
          {`${element.id} - ${element.nombre}`}
        </option>
      )
    }
    
    return salida
  }, [mesFin])

  return <Form.Select {...props}>{selectOpions}</Form.Select>
}

export default React.memo(MesContabilidad)
